// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__jM48h","modal":"Modal_modal__eCSWk","fullWidth":"Modal_fullWidth__JN28z"};